import moment from 'moment';

export function arrayToParam(arr) {
  return `[${arr.filter(Boolean).join(',')}]`;
}

export function yearOptions(min, max) {
  max = max || new Date().getFullYear();
  min = min || max - 50;
  const years = [];

  for (let i = max; i >= min; i--) {
    years.push({
      text: i,
      value: i
    });
  }

  return years;
}

export function yearLists(min, max) {
  min = min || new Date().getFullYear();
  max = max || min + 50;
  const years = [];

  for (let i = max; i >= min; i--) {
    years.push({
      text: i,
      value: i
    });
  }

  return years.reverse();
}

export function formatDate(value, format = 'DD-MM-YYYY') {
  if (!value) return null;

  return moment(value).format(format);
}

/**
 * Export to excel.
 *
 * @param columns
 * @param items
 * @param filename
 * @param sheetName
 */
export async function exportToExcel(
  columns = [],
  items = [],
  filename = 'Download',
  sheetName = 'Sheet 1'
) {
  const XLSX = await import('xlsx');
  const data = [columns, ...items];
  let worksheet = XLSX.utils.aoa_to_sheet(data);

  // fit column
  worksheet['!cols'] = fitToColumn(data);

  let new_workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(new_workbook, worksheet, sheetName);
  XLSX.writeFile(new_workbook, `${filename}.xlsx`);
}

function fitToColumn(arrayOfArray) {
  // get maximum character of each column
  return arrayOfArray[0].map((a, i) => ({
    wch: Math.max(...arrayOfArray.map(a2 => a2[i]?.toString()?.length))
  }));
}

export function getLocalUser() {
  return JSON.parse(localStorage.getItem('user') || '');
}
